export const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(String(email).toLowerCase());
};

export const validatePassword = (password: string): boolean => {
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_]).{8,}$/;
  return passwordRegex.test(password);
};

export const validateConfirmPassword = (
  password: string,
  comparer: string
): boolean => {
  return password === comparer;
};

export const validateRequired = (value: string | null | undefined): boolean => {
  return value != null && value.trim() !== "";
};

export const validateMaxLength = (
  value: string,
  maxLength: number
): boolean => {
  return value.length <= maxLength;
};

export const validateGreaterThanZero = (value: number): boolean => {
  return value > 0;
};

export const validateNigerianPhoneNumber = (value: string): boolean => {
  const phoneRegex =
    /^(\+234|234)?(0?\d{10}|\d{10})$|^(07|08|09)\d{9}$|^[789]\d{9}$/;
  return phoneRegex.test(value);
};

export const validateGender = (value: number | undefined | string): boolean => {
  return value === 1 || value === 2 || value === 3;
};

export const validateStatus = (value: number | undefined | string): boolean => {
  return (
    value === 0 || value === 1 || value === 2 || value === 3 || value === 4
  );
};

export const validateRole = (value: number | undefined | string): boolean => {
  return value === 0 || value === 1 || value === 2 || value === 3;
};

export const validateShortName = (value: string): boolean => {
  return value.length < 6;
};

export const sanitizeUrl = (url: string): string => {
  if (!/^https?:\/\//i.test(url)) {
    return `http://${url}`;
  }
  return url;
};

export const validateUrl = (url: string): boolean => {
  try {
    new URL(url);
    return true;
  } catch (_) {
    return false;
  }
};

// Form field validation functions
export const validateTextField = (
  value: string | null | undefined,
  required: boolean = false,
  maxLength?: number
): string => {
  if (required && !validateRequired(value)) {
    return "This field is required";
  }

  if (maxLength && value && !validateMaxLength(value, maxLength)) {
    return `Must be ${maxLength} characters or less`;
  }

  return "";
};

export const validateNumberField = (
  value: number | null | undefined,
  required: boolean = false,
  minValue?: number
): string => {
  if (required && (!value || !validateGreaterThanZero(value))) {
    return "This field is required and must be greater than 0";
  }

  if (minValue && value && value < minValue) {
    return `Must be at least ${minValue}`;
  }

  return "";
};

export const validateDateField = (
  value: string | null | undefined,
  required: boolean = false
): string => {
  if (required && !validateRequired(value)) {
    return "This field is required";
  }

  return "";
};

export const validateDateRange = (
  endDate: string | null | undefined,
  startDate: string | null | undefined,
  required: boolean = false
): string => {
  if (required && !validateRequired(endDate)) {
    return "End date is required";
  }

  if (endDate && startDate && endDate <= startDate) {
    return "End date must be after start date";
  }

  return "";
};

export const validateSelectField = (
  value: any,
  required: boolean = false
): string => {
  if (
    required &&
    ( value === "" || value === null || value === undefined)
  ) {
    return "This field is required";
  }

  return "";
};

export const validateBooleanField = (
  value: boolean | null | undefined,
  required: boolean = false
): string => {
  if (required && typeof value !== "boolean") {
    return "This field is required";
  }

  return "";
};

export const validateEmailField = (
  value: string | null | undefined,
  required: boolean = false
): string => {
  if (required && !validateEmail(value || "")) {
    return "Invalid email address";
  }
  return "";
};

export const validatePhoneField = (
  value: string | null | undefined,
  required: boolean = false
): string => {
  if (required && !validateNigerianPhoneNumber(value || "")) {
    return "Invalid Nigerian phone number";
  }
  return "";
};